import { isNaN } from './number';
export function isDate(date) {
  return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/utils/validate/date.js
// module id = null
// module chunks = 